// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023sdjhc/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
    },
  });
};

const detail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=` + id);
};

export { getBaseInfo, getRule, getNews, getList, detail };
